module.exports = __webpack_public_path__ + "static/media/amine3.12bbcc28.webp";